module.exports = __webpack_public_path__ + "static/images/icon-instagram.ac47d34dae7ef7ed2789924eefd5e008.svg";